export { default as GroupRegistrationListPage } from './GroupRegistrationListPage';
export { default as GroupRegistrationUploadPage } from './GroupRegistrationUploadPage';
export { default as GroupRegistrationDataPage } from './GroupRegistrationDataPage';
export { default as GroupRegistrationDetailPage } from './GroupRegistrationDetailPage';
